import { loadMonaco } from "@codeshare/editor";
import { appUpdater } from "./pwa/register";
import { getRoomController } from "./session/use-room";
import { getWorkspaceSession } from "./workspace/use-workspace";

/**
 * `window.codeshare` for diagnostics and tests: the live workspace session and room controller.
 * Contains no secrets beyond what's already in the address bar.
 */
export function exposeDebugHandle(): void {
  Object.defineProperty(window, "codeshare", {
    configurable: true,
    value: {
      get workspace() {
        return getWorkspaceSession();
      },
      get room() {
        return getRoomController();
      },
      updater: appUpdater,
      /** Text of every open editor model (what the editor holds, vs. the shared document). */
      async models() {
        const monaco = await loadMonaco();
        return monaco.editor.getModels().map((m) => ({
          uri: m.uri.toString(),
          language: m.getLanguageId(),
          value: m.getValue(),
        }));
      },
    },
  });
}
